import * as React from 'react'

function SvgCz(props) {
	return (
		<svg viewBox="0 0 900 600" width="1em" height="1em" {...props}>
			<path fill="#d7141a" d="M0 0h900v600H0z" />
			<path fill="#fff" d="M0 0h900v300H0z" />
			<path d="M450 300L0 0v600z" fill="#11457e" />
		</svg>
	)
}

export default SvgCz
